// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMemberAmountPropertyDto
 */
export interface IMemberAmountPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IMemberAmountPropertyDto
     */
    member_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IMemberAmountPropertyDto
     */
    member_amount_state?: IMemberAmountPropertyDtoMemberAmountStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMemberAmountPropertyDtoMemberAmountStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IMemberAmountPropertyDto interface.
 */
export function instanceOfIMemberAmountPropertyDto(value: object): value is IMemberAmountPropertyDto {
    return true;
}

export function IMemberAmountPropertyDtoFromJSON(json: any): IMemberAmountPropertyDto {
    return IMemberAmountPropertyDtoFromJSONTyped(json, false);
}

export function IMemberAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMemberAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'member_amount': json['member_amount'] == null ? undefined : json['member_amount'],
        'member_amount_state': json['member_amount_state'] == null ? undefined : json['member_amount_state'],
    };
}

export function IMemberAmountPropertyDtoToJSON(json: any): IMemberAmountPropertyDto {
    return IMemberAmountPropertyDtoToJSONTyped(json, false);
}

export function IMemberAmountPropertyDtoToJSONTyped(value?: IMemberAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'member_amount': value['member_amount'],
        'member_amount_state': value['member_amount_state'],
    };
}

